import { useMemo, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function useTemplateKey(key: string, makeComponents: () => Record<string, ReactNode>, dependencyList: unknown[]) {
    const { t } = useTranslation();

    //
    // Rendering the subcomponents could potentially be expensive.
    // However, even if not, we should only need to render the
    // embedded components once (and once per dependency change).
    //
    const components = useMemo(makeComponents, dependencyList);

    //
    // Build up an array of React nodes based on the string template.
    // This code replaces the string placeholders with components.
    //
    const nodes = useMemo<ReactNode>(() => {
        const template = t(key);
        const parts: ReactNode[] = [];
        template.replace(/([^<]*)(?:<([^>]+)\/>)?/g, (match, text: string, tag: string) => {
            if (text) {
                parts.push(
                    <span key={ parts.length.toString() }>
                        { text }
                    </span>
                );
            }
            if (tag && components[tag]) {
                parts.push(
                    <span key={ parts.length.toString() }>
                        { components[tag] }
                    </span>
                );
            }
            return '';
        });
        return parts;
    }, [ components, t ]);

    return nodes;
}
